import React from "react";

/**
 * @deprecated Use Breadcrumbs component from Aquilo instead.
 * This component will be removed in a future release.
 */
export type TopNavigationBreadcrumbProps = {
  title: string | string[];
  source?: string; // The top-level (first) breadcrumb shown next to the current page ("Source -> Current Page").
  sourceRoute?: string; // If provided, a route that the top-level breadcrumb will link to.
  contentInlineWithTitle?: React.ReactNode; // Any content (e.g. buttons) to put at the right of the title.
};

/**
 * @deprecated Use Breadcrumbs component from Aquilo instead.
 * This component will be removed in a future release.
 */
export function TopNavigationBreadcrumb({
  title,
  source = "Privacy Center",
  sourceRoute = null,
  contentInlineWithTitle = null,
}: TopNavigationBreadcrumbProps) {
  const ChevronRight = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      style={{ height: "20px", width: "12px" }}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
    </svg>
  );

  const renderBreadcrumbTitle = () => {
    if (Array.isArray(title)) {
      return title.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight />}
          <div className="font-medium text-neutral-500">{item}</div>
        </React.Fragment>
      ));
    }
    return <div className="font-medium text-neutral-500">{title}</div>;
  };

  return (
    <div className="tw-boundary">
      <div className="flex items-center gap-x-1.5">
        <div className="font-medium text-neutral-500">
          {sourceRoute ? (
            <button
              className="back-button"
              onClick={() => {
                window.location.href = sourceRoute;
              }}
            >
              <p className="back-button">{source}</p>
            </button>
          ) : (
            source
          )}
        </div>
        <ChevronRight />
        {renderBreadcrumbTitle()}
      </div>
      <div className="mt-3 mb-4 flex justify-space-between flex--align-end">
        <span className="text-primary-800 font-bold" style={{ fontSize: "30px" }}>
          {Array.isArray(title) ? title[title.length - 1] : title}
        </span>
        {contentInlineWithTitle}
      </div>
    </div>
  );
}
